/**
 * Image Search Agent - Context Engineering Section
 * Section 4: Context Engineering Note
 */
import { PromptSectionBase } from '../../../base/systemPrompt/PromptSectionBase';
import { IMAGE_SEARCH_PROMPT_KEYS } from './variables';
export const IMAGE_SEARCH_CONTEXT_PREFIXES = [
    'logo',
    'wikimedia',
    'asset',
];
class ImageSearchContextNoteSection extends PromptSectionBase {
    constructor() {
        super(...arguments);
        this.keywordsKey = IMAGE_SEARCH_PROMPT_KEYS.contextNote;
        this.fallbackContent = `## Context Engineering

Context items are passed with specific IDs that you must use correctly to link dynamic content.

### Context ID Prefixes

- **logo_xxx**: Brand logos from Brandfetch (company logos)
- **wikimedia_xxx**: Wikimedia images (stock photos, diagrams)
- **asset_xxx**: Presentation assets (embedded images, media)

### Using Context IDs

1. **Reference by ID**: When passing context to sub-agents, use the exact ID
   \`\`\`json
   { "context": ["logo_abc12", "wikimedia_xyz78"], "purpose": "Logos and images for slide" }
   \`\`\`

2. **Include purpose**: Always explain what the context is for

3. **Group related context**: Put related items in the same context array

4. **Don't fabricate IDs**: Only use IDs returned from tools/searches

### Asset ID Patterns

**Logo IDs (logo_xxx):**
- Logos from Brandfetch
- Format: logo_abc12
- Contains company logo in various formats

**Color IDs (color_xxx):**
- Brand colors from Brandfetch
- Format: color_xyz78
- Contains hex color values

**Wikimedia IDs (wikimedia_xxx):**
- Images from Wikimedia Commons
- Format: wikimedia_def45
- Contains downloaded image data

**Presentation IDs:**
- Images from existing presentations
- Format: deck_abc|slide_257|shape_42
- References embedded presentation images

### Using Asset IDs
1. ALWAYS call retrieve_* before submitting - search alone doesn't download assets
2. Use the EXACT assetId returned from retrieve tools
3. Multiple assets per requirement is OK (e.g., multiple logo variants)`;
    }
}
const contextNoteSection = new ImageSearchContextNoteSection();
/**
 * Get the context note section.
 * Uses Keywords AI if available, otherwise falls back to code.
 */
export function getContextNoteSection(hasResolvedContext = false) {
    let section = contextNoteSection.getContent();
    if (hasResolvedContext) {
        section += `\n\n**Note:** You have access to previously resolved context. Review it before searching to avoid redundant queries.`;
    }
    return section;
}
/**
 * Export constant for backwards compatibility
 */
export const IMAGE_SEARCH_CONTEXT_NOTE = contextNoteSection.getFallbackContent();
